/** 18 px round `@` marker for an unread mention. Sits before `UnreadPill`. */
export function MentionBadge({ className = '' }: { className?: string }) {
  return (
    <>
      <span
        aria-hidden='true'
        className={`flex h-[18px] w-[18px] shrink-0 items-center justify-center whitespace-nowrap rounded-full bg-amber-100 text-[11px] font-semibold leading-[18px] text-amber-900 ${className}`.trim()}
      >
        @
      </span>
      <span className='sr-only'>mentioned you</span>
    </>
  );
}
